/**
 * Floating Credit Estimator widget.
 */
( function () {
	'use strict';

	var DISMISS_STORAGE_KEY = 'creditEstimatorPillDismissed';
	var PILL_REVEAL_DELAY   = 3000; // ms

	document.addEventListener( 'DOMContentLoaded', function () {
		var widget = document.getElementById( 'credit-estimator-widget' );
		if ( ! widget ) {
			return;
		}

		/* ---------------- Elements ---------------- */
		var overlay       = document.getElementById( 'credit-estimator-overlay' );
		var toggleBtn     = document.getElementById( 'credit-estimator-toggle' );
		var iconToggleBtn = document.getElementById( 'credit-estimator-icon-toggle' );
		var dismissBtn    = document.getElementById( 'credit-estimator-dismiss' );
		var closeBtn      = document.getElementById( 'credit-estimator-close' );
		var panel         = document.getElementById( 'credit-estimator-panel' );
		var iframe        = document.getElementById( 'credit-estimator-iframe' );
		var loading       = document.getElementById( 'credit-estimator-loading' );

		var hasOpenedOnce = false;
		var lastFocused   = null;
		var closeTimeout  = null;

		function trackEvent( eventName, params ) {
			if ( typeof window.dataLayer !== 'undefined' ) {
				window.dataLayer.push( Object.assign( { event: eventName }, params || {} ) );
			}
		}

		function loadIframeIfNeeded() {
			if ( iframe.hasAttribute( 'data-src' ) ) {
				var src = iframe.getAttribute( 'data-src' );
				iframe.addEventListener( 'load', function onLoad() {
					loading.hidden = true;
					iframe.removeEventListener( 'load', onLoad );
				} );
				iframe.src = src;
				iframe.removeAttribute( 'data-src' );
			}
		}

		/* ---------------- Pill dismiss persistence + delayed reveal ---------------- */

		function isPillDismissed() {
			try {
				return window.sessionStorage.getItem( DISMISS_STORAGE_KEY ) === '1';
			} catch ( e ) {
				// Storage unavailable (e.g. private browsing, disabled cookies): fall back to not-dismissed.
				return false;
			}
		}

		function persistPillDismissed() {
			try {
				window.sessionStorage.setItem( DISMISS_STORAGE_KEY, '1' );
			} catch ( e ) {
				// Ignore storage errors; the dismissal still applies for the current page view.
			}
		}

		if ( isPillDismissed() ) {
			// Dismissed earlier this session (still true on other pages until the tab/browser closes): keep it hidden, skip the reveal timer.
			widget.classList.add( 'is-dismissed' );
		} else {
			setTimeout( function () {
				// Guard in case the user dismissed it during the delay (e.g. via another tab/action).
				if ( ! widget.classList.contains( 'is-dismissed' ) ) {
					widget.classList.add( 'is-pill-visible' );
				}
			}, PILL_REVEAL_DELAY );
		}

		/* ---------------- Open/close helpers ---------------- */

		function showOverlay() {
			overlay.hidden = false;
			void overlay.offsetHeight;
		}

		function hideOverlay() {
			overlay.hidden = true;
		}

		function openEstimator() {
			lastFocused = document.activeElement;

			if ( closeTimeout ) {
				clearTimeout( closeTimeout );
				closeTimeout = null;
			}
			panel.removeEventListener( 'transitionend', finishCloseEstimator );

			showOverlay();
			panel.hidden = false;

			void panel.offsetHeight;

			requestAnimationFrame( function () {
				widget.classList.add( 'is-open' );
				document.body.classList.add( 'credit-estimator-open' );
				toggleBtn.setAttribute( 'aria-expanded', 'true' );
				if ( iconToggleBtn ) {
					iconToggleBtn.setAttribute( 'aria-expanded', 'true' );
				}
			} );

			loadIframeIfNeeded();

			if ( ! hasOpenedOnce ) {
				hasOpenedOnce = true;
				trackEvent( 'widget_opened' );
			}

			closeBtn.focus();
			document.addEventListener( 'keydown', handleKeydown );
		}

		function finishCloseEstimator( event ) {
			if ( event && event.target !== panel ) {
				return;
			}
			panel.hidden = true;
			hideOverlay();
			panel.removeEventListener( 'transitionend', finishCloseEstimator );
			closeTimeout = null;
		}

		function closeEstimator( skipFocusReturn ) {
			widget.classList.remove( 'is-open' );
			document.body.classList.remove( 'credit-estimator-open' );
			toggleBtn.setAttribute( 'aria-expanded', 'false' );
			if ( iconToggleBtn ) {
				iconToggleBtn.setAttribute( 'aria-expanded', 'false' );
			}

			panel.addEventListener( 'transitionend', finishCloseEstimator );
			closeTimeout = setTimeout( finishCloseEstimator, 350 );

			document.removeEventListener( 'keydown', handleKeydown );

			if ( ! skipFocusReturn ) {
				if ( lastFocused && typeof lastFocused.focus === 'function' ) {
					lastFocused.focus();
				} else {
					toggleBtn.focus();
				}
			}
		}

		function handleKeydown( event ) {
			if ( event.key === 'Escape' || event.key === 'Esc' ) {
				closeEstimator();
				return;
			}

			// Minimal focus trap for the panel.
			if ( event.key === 'Tab' ) {
				var focusable = panel.querySelectorAll(
					'button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])'
				);
				if ( ! focusable.length ) {
					return;
				}
				var first = focusable[ 0 ];
				var last  = focusable[ focusable.length - 1 ];

				if ( event.shiftKey && document.activeElement === first ) {
					event.preventDefault();
					last.focus();
				} else if ( ! event.shiftKey && document.activeElement === last ) {
					event.preventDefault();
					first.focus();
				}
			}
		}

		/* ---------------- Event bindings ---------------- */

		toggleBtn.addEventListener( 'click', function () {
			var isOpen = widget.classList.contains( 'is-open' );
			if ( isOpen ) {
				closeEstimator();
			} else {
				openEstimator();
			}
		} );

		if ( iconToggleBtn ) {
			iconToggleBtn.addEventListener( 'click', function () {
				var isOpen = widget.classList.contains( 'is-open' );
				if ( isOpen ) {
					closeEstimator();
				} else {
					openEstimator();
				}
			} );
		}

		closeBtn.addEventListener( 'click', function () {
			closeEstimator();
		} );

		if ( dismissBtn ) {
			dismissBtn.addEventListener( 'click', function ( event ) {
				event.stopPropagation();
				widget.classList.add( 'is-dismissed' );
				persistPillDismissed();
			} );
		}

		overlay.addEventListener( 'click', closeEstimator );

	} );
} )();